import cheerio from "cheerio";
import axios from "axios";
import Constants from "../helper/Constants";

const removeWhiteSpaceAndBr = (obj) => {
  const removedWhiteSpaceNodes = Object.keys(obj)
    .filter((key) => obj[key].name)
    .filter((key) => obj[key].name !== "br")
    .map((newKey) => obj[newKey]);

  return removedWhiteSpaceNodes;
};

const flattenNodes = (arr) => {
  if (Array.isArray(arr)) {
    return arr.reduce((done, curr) => {
      if (curr.children !== undefined && curr.children.length > 0) {
        return done.concat(flattenNodes(curr.children));
      }
      return done.concat(flattenNodes(curr));
    }, []);
  }

  return arr;
};

const getScriptTag = (arr) => {
  const scriptTag = flattenNodes(arr).filter(
    (node) => node.type === "script"
  )[0];

  if (scriptTag) {
    return scriptTag;
  }

  return false;
};

const getOldPost = ($) => {
  let node;
  $("div").each((i, elem) => {
    if (elem.attribs) {
      if (elem.attribs.id) {
        if (elem.attribs.id.match("nar_root_.*")) {
          node = elem;
        }
      }
    }
  });

  return node;
};

const getAllOldNodes = (arr) => {
  const nodeArray = [];

  if (arr === undefined && arr.length === 0) {
    return;
  }

  if (arr && arr.length === 1 && arr.children !== undefined) {
    nodeArray.push(arr[0]);
    return nodeArray;
  }

  for (let i = 0; i < arr.length; i += 1) {
    if (arr[i].children !== undefined && arr[i].children.length > 0) {
      const childrenArray = getAllOldNodes(arr[i].children);
      childrenArray.forEach((node) => nodeArray.push(node));
    }
    nodeArray.push(arr[i]);
  }

  return nodeArray;
};

const getOldScriptTag = (arr) => {
  const scriptTag = getAllOldNodes(arr).filter(
    (node) => node.type === "script"
  )[0];

  return scriptTag;
};

const scriptTagContainsInvalidParent = (node) => {
  const { name } = node.parent;

  const hTagCheck =
    name === "h1" ||
    name === "h2" ||
    name === "h3" ||
    name === "h4" ||
    name === "h5" ||
    name === "h6" ||
    name === "header";

  const pTagCheck = name === "p";
  const aTagCheck = name === "a";
  const unorderedListCheck = name === "ul";
  const boldCheck = name === "b";
  const italicCheck = name === "i";

  if (hTagCheck) {
    return Constants.DOM.SecondaryErrorMessage.SCRIPT_TAG_CONTAINS_HEADER_TAG;
  }

  if (pTagCheck) {
    return Constants.DOM.SecondaryErrorMessage.SCRIPT_TAG_CONTAINS_P_TAG;
  }

  if (aTagCheck) {
    return Constants.DOM.SecondaryErrorMessage.SCRIPT_TAG_CONTAINS_A_TAG;
  }

  if (unorderedListCheck) {
    return Constants.DOM.SecondaryErrorMessage
      .SCRIPT_TAG_CONTAINS_UNORDEREDLIST_TAG;
  }

  if (boldCheck) {
    return Constants.DOM.SecondaryErrorMessageSCRIPT_TAG_CONTAINS_BOLD_TAG;
  }

  if (italicCheck) {
    return Constants.DOM.SecondaryErrorMessage.SCRIPT_TAG_CONTAINS_ITALIC_TAG;
  }

  return false;
};

const blogExistsInCodeTag = (codeTag) => {
  let isBlogInsideCodeTag = false;
  if (codeTag && codeTag.length > 0 && codeTag["0"].children) {
    codeTag.each((_, ele) => {
      if (ele.children["0"].data) {
        const htmlString = ele.children["0"].data;
        const parsedHTML = cheerio.load(htmlString);
        const postID = parsedHTML(".nar-root").attr("data-post-id");

        if (postID) {
          isBlogInsideCodeTag = true;
        }
      }
    });
  }

  return isBlogInsideCodeTag;
};

const walkDOM = (root, arr) => {
  if (
    root.data &&
    root.data.length > 5 &&
    /\S/.test(root.data) &&
    root.data.substring(0, 4) === "<div"
  ) {
    const dataPostID = root.data.split(" ")[2];
    const id = dataPostID
      .split("=")[1]
      .replace("′", "")
      .replace("’", "")
      .replace("’", "");
    arr.push(id);

    return;
  }

  if (!root.children || arr.length === 1) {
    return;
  }

  if (root && root.children) {
    for (let i = 0; i < root.children.length; i += 1) {
      const children = root.children;
      walkDOM(children[i], arr);
    }
  }
};

const DOMCheck = (url) => {
  return new Promise((resolve, reject) => {
    const corsURL = `${process.env.CORS_PROXY_URL}${url}`;
    axios
      .get(corsURL)
      .then((res) => {
        const { data } = res;
        const $ = cheerio.load(data);
        const newPost = $(".nar-root");
        let scriptTag;
        const errorObj = {
          mainTitle: Constants.DOM.MainErrorMessage.SCRIPT_TAG_FAILED
        };

        console.log(newPost);

        if (blogExistsInCodeTag($("code"))) {
          errorObj.subTitle =
            Constants.DOM.SecondaryErrorMessage.SCRIPT_TAG_IN_CODE_TAG;
          reject(errorObj);
          return;
        }

        const root = $("body");
        const idArr = [];
        walkDOM(root["0"], idArr);
        if (idArr.length === 1) {
          errorObj.subTitle =
            Constants.DOM.SecondaryErrorMessage.SCRIPT_TAG_IN_CLASSIC_EDITOR;
          reject(errorObj);
          return;
        }

        if (newPost.length > 0) {
          const getContents = newPost.contents();
          scriptTag = getScriptTag(removeWhiteSpaceAndBr(getContents));
          console.log(scriptTag);
        }

        if (newPost.length === 0) {
          const oldPost = getOldPost($);
          if (oldPost) {
            scriptTag = getOldScriptTag(
              getAllOldNodes(removeWhiteSpaceAndBr(oldPost.children))
            );
          } else {
            errorObj.subTitle =
              Constants.DOM.SecondaryErrorMessage.BLOG_NOT_FOUND;
            reject(errorObj);
          }
        }

        if (!scriptTag) {
          errorObj.subTitle =
            Constants.DOM.SecondaryErrorMessage.SCRIPT_TAG_NOT_FOUND;
          reject(errorObj);
        }

        if (!scriptTagContainsInvalidParent(scriptTag)) {
          resolve(Constants.DOM.SuccessMessage.SCRIPT_TAG_VALID);
        } else {
          errorObj.subTitle = scriptTagContainsInvalidParent(scriptTag);
          reject(errorObj);
        }
      })
      .catch((err) => console.log(err));
  });
};

export default DOMCheck;
